import usePageMeta from '@/hooks/usePageMeta';
import HeroSection from '@/pages/home/components/HeroSection';
import RiskChecklist from '@/pages/home/components/RiskChecklist';
import LatestIncidents from '@/pages/home/components/LatestIncidents';
import TopicSection from '@/pages/home/components/TopicSection';
import FaqSection from '@/pages/home/components/FaqSection';
import ReportCta from '@/pages/home/components/ReportCta';
import { faqs } from '@/mocks/site';

const jsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '黑料雷达',
    url: 'https://worswgu.cn/',
    description: '聚焦网站安全事件与隐私风险的中文情报站',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://worswgu.cn/incidents?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: { '@type': 'Answer', text: faq.answer },
    })),
  },
];

export default function Home() {
  usePageMeta({
    title: '黑料雷达｜网站安全事件与隐私风险情报站',
    description:
      '黑料雷达整理数据泄露、安全漏洞、盗刷事件、违规收集使用个人信息与监管处罚记录，提供风险自查方法与自保建议，帮你提前识别高风险平台。',
    keywords: '网站黑料,数据泄露,安全漏洞,盗刷事件,隐私风险,违规收集,监管处罚',
    canonical: '/',
    jsonLd,
  });

  return (
    <>
      <HeroSection />
      <LatestIncidents />
      <RiskChecklist />
      <TopicSection />
      <FaqSection />
      <ReportCta />
    </>
  );
}